import React from 'react'

const IconCoins = ({ style }) => {
   return (
      <svg viewBox='0 0 24 24' width='16' height='16' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' style={style}>
         <circle cx='12' cy='12' r='8' />
         <circle cx='12' cy='12' r='4' />
      </svg>
   )
}
export default IconCoins
